import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import moment from "moment";
import "./Matcher.scss";
import {
  Button,
  Checkbox,
  Collapse,
  Input,
  message,
  Select,
  Tag,
  Typography,
  Drawer,
  Modal
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { debounce, set } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel } from "@fortawesome/free-solid-svg-icons";

import {
  DoubleRightOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  CopyOutlined,
  LoadingOutlined,
  CheckOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Resizable } from "react-resizable";
import { use } from "react";
// import { getPresignedUrl } from "../utils/s3PresignedUrl";
import { getPresignedUrl } from "../ManualValidation/presingedurl";
import PageHeader from "app/shared/PageHeader";
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;



function validateGSTIN(gstin) {
  const gstinPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
  return gstinPattern.test(gstin);
}

export default function Matcher(props) {
  const [matchDocument, setMatchDocument] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [validatedHSN332Amount, setValidatedHSN332Amount] = useState("");
  const [validatedGSTAmount, setValidatedGSTAmount] = useState("");
  const [validatedInvoiceAmount, setValidatedInvoiceAmount] = useState("");
  const [gstAmountInput, setGstAmountInput] = useState("");
  const [invoiceNumberInput, setInvoiceNumberInput] = useState("");
  const [invoiceAmountInput, setInvoiceAmountInput] = useState("");
  const [invoiceDateInput, setInvoiceDateInput] = useState("");
  const [clientGSTIN, setClientGSTIN] = useState("");
  const [clientWorkspace, setClientWorkspace] = useState("");
  const [clientEnteredGSTIN, setClientEnteredGSTIN] = useState("");
  const [hotelEnteredGSTIN, setHotelEnteredGSTIN] = useState("");
  const [hotelGSTIN, setHotelGSTIN] = useState("");
  const [hotelGSTINInput, setHotelGSTINInput] = useState("");
  const [hotelName, setHotelName] = useState("");
  const [hotelNameInput, setHotelNameInput] = useState("");
  const [enableHotelCreate, setEnableHotelCreate] = useState(false);
  const [enableClientGSTIN, setEnableClientGSTIN] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [selected2BMatch, setSelected2BMatch] = useState(null);
  const [selectedBookingMatch, setSelectedBookingMatch] = useState(null);
  const [selectedIssue, setSelectedIssue] = useState("");
  const [rowData, setRowData] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [clientLoading, setClientLoading] = useState(false);
  const [hotelLoading, setHotelLoading] = useState(false);
  const [width, setWidth] = useState(400);
  const { documentId } = useParams();
  const [totalCount, setTotalCount] = useState(0)
  const [currenntDoc, setCurrentDoc] = useState(0)
  const [validatedInvoiceDate, setValidatedInvoiceDate] = useState(null)
  const [attachment_url, setAttachment_url] = useState("")
  const [message_date, setMessage_date] = useState("")
  const inputRefs = {
    "11": useRef(null),
    "12": useRef(null),
    "13": useRef(null),
    "14": useRef(null),
    "15": useRef(null),
    "16": useRef(null),
    "17": useRef(null),
    "18": useRef(null),
    "19": useRef(null),
  };

  const [bookingRowData, setBookingRowData] = useState([]);
  const [amount996331, setAmount996331] = useState(0);
  const [amount996332, setAmount99632] = useState(0);
  const [amount996334, setAmount996334] = useState(0);
  const [amount99639, setAmount996339] = useState(0);
  const [amount996311, setAmount996311] = useState(0);
  const [invoiceNumber, setInvoiceNumber] = useState(0)
  const [isNonInvoice, setIsNonInvoice] = useState(false)
  const [workspaceStatusTag, setWorkspaceStatusTag] = useState("Validation Required")
  const [hotelStatusTag, setHotelStatusTag] = useState("Validation Required")
  const [parsedStatusTag, setParsedStatusTag] = useState("Validation Required")
  const [skipGSTIN, setSkipGSTIN] = useState(false);
  const [skipBookingGSTIN, setSkipBookingGSTIN] = useState(false)
  const [assetLink, setAssetLink] = useState("")
  const [document_id, setDocument_id] = useState("")

  const [filterType, setFilterType] = useState("All");
  const [filterValue, setFilterValue] = useState("");
  const [showMoreParsedData, setShowMoreParsedData] = useState(false);
  const [dynamicFieldValues, setDynamicFieldValues] = useState({});
  const [dynamicFieldInputValues, setDynamicFieldInputValues] = useState({}); // First input box values
  const [dynamicFieldOutputValues, setDynamicFieldOutputValues] = useState({}); // Second input box values (mandatory)
  const [clientList, setClientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedClientPan, setSelectedClientPan] = useState("");
  const [clientListLoading, setClientListLoading] = useState(false);
  const [currentFilterPanNumbers, setCurrentFilterPanNumbers] = useState([]);
  const [currentFilterGstinNumbers, setCurrentFilterGstinNumbers] = useState([]);




  const [isExpanded, setIsExpanded] = useState(false);


  const [pdfDimensions, setPdfDimensions] = useState({ width: '34%', height: '100%' });
  const [pdfIsResizing, setPdfIsResizing] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [noMatch, setNoMatch] = useState(false);
  const startResizing = (e) => {
    e.preventDefault();
    setPdfIsResizing(true);
  };

  const stopResizing = () => {
    if (pdfIsResizing) {
      setPdfIsResizing(false);
    }
  };

  const onResize = (e) => {
    if (pdfIsResizing) {
      const parentElement = e.currentTarget.parentElement;
      const parentWidth = parentElement.offsetWidth;
      const newWidthPixels = e.clientX - parentElement.getBoundingClientRect().left;

      const maxWidthPixels = parentWidth * 0.1;

      const finalWidth = newWidthPixels > 0 && newWidthPixels <= maxWidthPixels
        ? newWidthPixels : parseFloat(dimensions.width) / 100 * parentWidth;

      setPdfDimensions({
        width: `${(finalWidth / parentWidth) * 100}%`,
        height: dimensions.height,
      });
    }
  };

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth * 0.4,
    height: '100%',
  });
  const { Option } = Select
  const navigate = useNavigate();
  const handleLeftArrowClick = () => {
    navigate("/outputTable");
  };



  const [isResizing, setIsResizing] = useState(false);

  const handleMouseDown = (e) => {
    e.preventDefault(); // Prevent default behavior
    setIsResizing(true);

    const startX = e.clientX;
    const startY = e.clientY;

    const startWidth = dimensions.width;
    const startHeight = dimensions.height;

    // Event listeners to resize on drag
    const handleMouseMove = (e) => {
      if (!isResizing) return;

      const newWidth = startWidth + (e.clientX - startX);
      const newHeight = startHeight + (e.clientY - startY);

      setDimensions({
        width: Math.max(newWidth, 100), // Minimum width: 100px
        height: Math.max(newHeight, 50), // Minimum height: 50px
      });
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    // Attach global event listeners for dragging
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // State to control Drawer visibility

  const openDrawer = () => {
    setIsDrawerOpen(true); // Open the Drawer
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false); // Close the Drawer
  };

  useEffect(() => {
    if (documentId) {
      fetchDocumentWithId();
    } else {
      fetchDocument();
    }
  }, [documentId])

  // State to track validation errors for highlighting
  const [validationErrors, setValidationErrors] = useState({
    clientGSTIN: false,
    hotelName: false,
    hotelGSTIN: false,
    gstAmount: false,
    invoiceNumber: false,
    invoiceAmount: false,
    invoiceDate: false,
    showMoreFields: {}
  });

  // Helper function to check if a value is empty (considering 0, [], and "" as valid)
  const isEmptyValue = (value) => {
    if (value === null || value === undefined) return true;
    // Empty string "" is a valid value (if it exists in original document)
    if (typeof value === 'string' && value === "") return false; // "" is valid
    if (typeof value === 'string' && value.trim() === "" && value !== "") return true; // Whitespace-only strings are invalid
    if (typeof value === 'number' && value === 0) return false; // 0 is a valid value
    if (Array.isArray(value) && value.length === 0) return false; // Empty array [] is a valid value
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) return true;
    return false;
  };

  // Function to check if all required fields are filled
  const validateAllFields = () => {
    const errors = {
      clientGSTIN: false,
      hotelName: false,
      hotelGSTIN: false,
      gstAmount: false,
      invoiceNumber: false,
      invoiceAmount: false,
      invoiceDate: false,
      showMoreFields: {}
    };

    // Validate Client Detail
    const isClientGSTINFilled = clientEnteredGSTIN && clientEnteredGSTIN.trim() !== "";
    errors.clientGSTIN = !isClientGSTINFilled;

    // Validate Hotel Detail
    const isHotelNameFilled = hotelName && hotelName.trim() !== "";
    const isHotelGSTINFilled = hotelGSTIN && hotelGSTIN.trim() !== "";
    errors.hotelName = !isHotelNameFilled;
    errors.hotelGSTIN = !isHotelGSTINFilled;

    // Validate Parsed data
    const isGSTAmountFilled = validatedGSTAmount !== null && validatedGSTAmount !== undefined &&
      (validatedGSTAmount.toString().trim() !== "" || validatedGSTAmount === 0);
    const isInvoiceNumberFilled = invoiceNumber !== null && invoiceNumber !== undefined &&
      (invoiceNumber.toString().trim() !== "" || invoiceNumber === 0);
    const isInvoiceAmountFilled = validatedInvoiceAmount !== null && validatedInvoiceAmount !== undefined &&
      (validatedInvoiceAmount.toString().trim() !== "" || validatedInvoiceAmount === 0);
    const isInvoiceDateFilled = validatedInvoiceDate && validatedInvoiceDate.toString().trim() !== "";
    errors.gstAmount = !isGSTAmountFilled;
    errors.invoiceNumber = !isInvoiceNumberFilled;
    errors.invoiceAmount = !isInvoiceAmountFilled;
    errors.invoiceDate = !isInvoiceDateFilled;

    // Validate Show More fields (only fields that exist in original document)
    if (matchDocument) {
      const excludedFields = [
        'total_tax_amount',
        'invoice_number',
        'invoice_amount',
        'invoice_date',
        'guest_gstin',
        'hotel_gstin',
        'hotel_name'
      ];

      // Show More fields are optional - no validation errors
      // They are auto-populated but not required
    }

    setValidationErrors(errors);

    // Check if all fields are valid (Show More fields are optional, so don't check them)
    const hasErrors = errors.clientGSTIN || errors.hotelName || errors.hotelGSTIN ||
      errors.gstAmount || errors.invoiceNumber || errors.invoiceAmount ||
      errors.invoiceDate;

    return !hasErrors;
  };

  // Function to validate Client Detail section
  const validateClientDetail = () => {
    const isClientGSTINFilled = clientEnteredGSTIN && clientEnteredGSTIN.trim() !== "";
    setWorkspaceStatusTag(isClientGSTINFilled ? "Validated" : "Validation Required");
  };

  // Function to validate Hotel Detail section
  const validateHotelDetail = () => {
    const isHotelNameFilled = hotelName && hotelName.trim() !== "";
    const isHotelGSTINFilled = hotelGSTIN && hotelGSTIN.trim() !== "";
    const allFieldsFilled = isHotelNameFilled && isHotelGSTINFilled;
    setHotelStatusTag(allFieldsFilled ? "Validated" : "Validation Required");
  };

  // Function to validate Parsed data section
  const validateParsedData = () => {
    const isGSTAmountFilled = validatedGSTAmount !== null && validatedGSTAmount !== undefined &&
      (validatedGSTAmount.toString().trim() !== "" || validatedGSTAmount === 0);
    const isInvoiceNumberFilled = invoiceNumber !== null && invoiceNumber !== undefined &&
      (invoiceNumber.toString().trim() !== "" || invoiceNumber === 0);
    const isInvoiceAmountFilled = validatedInvoiceAmount !== null && validatedInvoiceAmount !== undefined &&
      (validatedInvoiceAmount.toString().trim() !== "" || validatedInvoiceAmount === 0);
    const isInvoiceDateFilled = validatedInvoiceDate && validatedInvoiceDate.toString().trim() !== "";

    // Show More fields are optional - always considered filled
    // They are auto-populated but not required for validation
    const allShowMoreFieldsFilled = true;

    const allFieldsFilled = isGSTAmountFilled && isInvoiceNumberFilled &&
      isInvoiceAmountFilled && isInvoiceDateFilled && allShowMoreFieldsFilled;
    setParsedStatusTag(allFieldsFilled ? "Validated" : "Validation Required");
  };

  // Track if save button should be disabled
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  // Update validation tags when relevant state changes
  useEffect(() => {
    validateClientDetail();
  }, [clientEnteredGSTIN]);

  useEffect(() => {
    validateHotelDetail();
  }, [hotelName, hotelGSTIN]);

  useEffect(() => {
    validateParsedData();
  }, [validatedGSTAmount, invoiceNumber, validatedInvoiceAmount, validatedInvoiceDate, dynamicFieldOutputValues, showMoreParsedData, matchDocument]);

  // Update save button state and validation errors whenever relevant state changes
  useEffect(() => {
    const isValid = validateAllFields();
    setIsSaveDisabled(!isValid);
  }, [clientEnteredGSTIN, hotelName, hotelGSTIN, validatedGSTAmount, invoiceNumber, validatedInvoiceAmount, validatedInvoiceDate, dynamicFieldOutputValues, matchDocument]);


  const fetchDocumentWithId = async () => {
    setLoading(true);
    const response = await axios.get(
      `https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document?documentId=${documentId}`
    );

    if (response.status) {
      setMatchDocument(response.data.data?.AI_parsed_data.parsed_data);
      setRowData(response.data.data?.two_b_matches);

      // Add these lines to fix the blank PDF issue
      const attachmentUrl = response.data?.data?.attachment_url;
      if (attachmentUrl) {
        const presignedUrl = await getPresignedUrl(attachmentUrl);
        setAssetLink(presignedUrl);
      } else {
        setAssetLink("");
      }

      setAttachment_url(attachmentUrl || "");
      setMessage_date(response.data?.data?.message_date || "");
      setDocument_id(response.data.data?._id);
    }
    setLoading(false);
  };


  const fetchDocument = async (filterParams = {}) => {
    setLoading(true);
    let url = `https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document`;
    // let url = `http://localhost:7002/api/fuzzy/match_document`;

    // Build query parameters if filter is applied
    if (filterParams.type && filterParams.type !== "All" && filterParams.value) {
      const params = new URLSearchParams();
      params.append(filterParams.type, filterParams.value);
      // Add PAN numbers if provided (for client_name filter)
      if (filterParams.pan_numbers && filterParams.pan_numbers.length > 0) {
        params.append('pan_numbers', filterParams.pan_numbers.join(','));
      }
      // Add GSTIN numbers if provided (for client_gstin or hotel_gstin filter)
      if (filterParams.gstin_numbers && filterParams.gstin_numbers.length > 0) {
        params.append('gstin_numbers', filterParams.gstin_numbers.join(','));
      }
      url += `?${params.toString()}`;
    }
    // Fetch the next document without priority
    const response = await axios.get(url);
    if (response.status) {
      setMatchDocument(response?.data?.data?.AI_parsed_data?.parsed_data);
      setDocument_id(response.data.data?._id)

      // Get pre-signed URL for S3 URLs
      const attachmentUrl = response.data?.data?.attachment_url;
      if (attachmentUrl) {
        const presignedUrl = await getPresignedUrl(attachmentUrl);
        setAssetLink(presignedUrl);
      } else {
        setAssetLink("");
      }
      setRowData(response.data?.data?.two_b_matches);
      setTotalCount(response?.data?.totalCount)
      setCurrentDoc(response.data?.seenCount)
      setClientGSTIN(response.data?.data?.guest_gstin || ""); // Map GSTIN to first input box
      setClientEnteredGSTIN(""); // Clear second input box
      setHotelNameInput(""); // Clear hotel name first input box
      setHotelGSTINInput(""); // Clear hotel GSTIN first input box
      setWorkspaceStatusTag("Validation Required");
      setHotelStatusTag("Validation Required");
      setParsedStatusTag("Validation Required");
      setDynamicFieldValues({}); // Reset dynamic field values when fetching new document
      setDynamicFieldInputValues({}); // Reset first input box values
      // Reset parsed data input fields (first input boxes)
      setGstAmountInput("");
      setInvoiceNumberInput("");
      setInvoiceAmountInput("");
      setInvoiceDateInput("");
      // Reset parsed data validated fields (second input boxes)
      setValidatedGSTAmount("");
      setInvoiceNumber("");
      setValidatedInvoiceAmount("");
      setValidatedInvoiceDate(null);
      setAttachment_url(response.data?.data?.attachment_url || "");
      setMessage_date(response.data?.data?.message_date || "")

      // Auto-populate Show More fields (second input boxes) with original values
      const parsedData = response?.data?.data?.AI_parsed_data?.parsed_data;
      const initialOutputValues = {};
      if (parsedData) {
        const excludedFields = [
          'total_tax_amount',
          'invoice_number',
          'invoice_amount',
          'invoice_date',
          'guest_gstin',
          'hotel_gstin',
          'hotel_name',
          'No' // Exclude "No" field as it causes MongoDB conflicts
        ];

        Object.entries(parsedData).forEach(([key, originalValue]) => {
          // Only auto-populate Show More fields that exist (not null/undefined) and are not excluded
          const fieldExists = originalValue !== null && originalValue !== undefined;
          if (!excludedFields.includes(key) && fieldExists) {
            // Auto-populate with original value (including "", 0, [])
            initialOutputValues[key] = originalValue;
          }
        });
      }
      setDynamicFieldOutputValues(initialOutputValues);

      // Reset checkbox selections when fetching a new document
      setSelected2BMatch(null);
      setSelectedBookingMatch(null);
      setIsNonInvoice(false);

      // Reset validation errors
      setValidationErrors({
        clientGSTIN: false,
        hotelName: false,
        hotelGSTIN: false,
        gstAmount: false,
        invoiceNumber: false,
        invoiceAmount: false,
        invoiceDate: false,
        showMoreFields: {}
      });
      setIsSaveDisabled(true);
    }
    setLoading(false);
  };

  const fetchClientInfoByPan = async (retryCount = 0) => {
    setClientListLoading(true);
    try {
      const response = await axios.get(
        "https://stage-apiplatform.finkraftai.com/api/fuzzy/clientInfo/pan"
      );
      if (response.status && response.data?.status && response.data?.data) {
        setClientList(response.data.data);
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching client info by PAN:", error);

      // Retry logic: retry up to 3 times with exponential backoff
      if (retryCount < 3) {
        const delay = Math.pow(2, retryCount) * 1000; // 1s, 2s, 4s
        setTimeout(() => {
          fetchClientInfoByPan(retryCount + 1);
        }, delay);
        return null;
      }

      // Only show error message after all retries failed
      if (retryCount >= 3) {
        messageApi.open({
          type: "error",
          content: "Failed to fetch client info. Please try again later.",
          duration: 3,
        });
      }
      return null;
    } finally {
      // Only set loading to false if not retrying
      if (retryCount >= 3 || retryCount === 0) {
        setClientListLoading(false);
      }
    }
  };

  const handleClientSelect = async (clientId) => {
    const selectedClientData = clientList.find(client => client._id === clientId);
    if (selectedClientData) {
      setSelectedClient(selectedClientData);
      // Set first PAN as default if available
      const panNumber = selectedClientData.pan_numbers?.[0] || "";
      setSelectedClientPan(panNumber);

      // Call fetchDocument with client_name filter using the client name
      if (selectedClientData.client_name) {
        await fetchDocument({ type: "client_name", value: selectedClientData.client_name });
      }
    }
  };

  const handlePanSelect = (panNumber) => {
    setSelectedClientPan(panNumber);
  };

  // Fetch client list initially on component mount
  useEffect(() => {
    // Add a small delay to ensure API is ready after page refresh
    const timer = setTimeout(() => {
      fetchClientInfoByPan();
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (matchDocument) {
      // Call the function only when matchDocument is present
      fetch2bmatchsElastic();// Uncomment if needed
      fetchBookingElasticMatches();
    }
  }, [matchDocument]);

  const twoBGridColumnDefs = useMemo(() => {
    const data = rowData || matchDocument?.two_b_matches || [];
    const selectColumn = {
      headerName: "Select",
      width: 120,
      cellRenderer: (params) => {
        const currentRowId = params.data?._id;
        const selectedRowId = selected2BMatch?._id;
        const isChecked = selected2BMatch !== null &&
          currentRowId !== undefined &&
          selectedRowId !== undefined &&
          String(currentRowId) === String(selectedRowId);
        return (
          <Checkbox
            checked={isChecked}
            onChange={() => setSelected2BMatch(params.data)}
          />
        );
      },
    };
    const dataKeys = data.length
      ? [...new Set(data.flatMap((row) => Object.keys(row || {})))]
      : [];
    const dynamicColumns = dataKeys
      .filter((key) => key !== "_id")
      .map((key) => ({
        headerName: key,
        field: key,
        width: 120,
        valueGetter: (params) => params.data?.[key],
      }));
    return [selectColumn, ...dynamicColumns];
  }, [rowData, matchDocument?.two_b_matches, selected2BMatch]);

  const fetch2bmatchsElastic = async (input = "") => {
    const scroll_time = "2m"
    const batch_size = 50
    const esUrl =
      "https://dev-elastic.finkraftai.com";

    let queryParts = [];
    const headers = {
      'Content-Type': 'application/json',
    };
    // Include GSTINs only if skipGSTIN is false
    if (!skipGSTIN) {
      if (hotelGSTIN) {
        queryParts.push(`${hotelGSTIN}`);
      } else if (matchDocument?.hotel_gstin) {
        queryParts.push(`${matchDocument?.hotel_gstin}`);
      }

      if (clientGSTIN) {
        queryParts.push(`${clientGSTIN}`);
      } else if (matchDocument?.guest_gstin) {
        queryParts.push(`${matchDocument?.guest_gstin}`);
      }
    }
    // Process user input from search bar (e.g. invoice number) — wrap with *term* for wildcard; GSTINs stay as-is
    const userQueries = input
      .split(",")
      .map((term) => term.trim())
      .filter((term) => term);

    if (userQueries.length > 0) {
      queryParts = queryParts.concat(userQueries.map((term) => `*${term}*`));
    }
    // Construct the final query string
    const queryStr = queryParts.length ? queryParts.join(" AND ") : "";

    const searchQuery = {
      size: batch_size,
      query: {
        query_string: {
          query: queryStr,
          fields: ["*"],
          default_operator: "AND",
          analyze_wildcard: true,
          fuzziness: "AUTO",
          lenient: true
        }
      },
      sort: [{ _score: { order: "desc" } }]
    };


    try {

      const response = await axios.post(
        `${esUrl}/hotel_za_master_data/_search?scroll=${scroll_time}`,
        searchQuery, // ✅ This goes into the body
        { headers }
      );
      const hits = response.data?.hits.hits || [];
      if (hits.length > 0) {
        // Include _id in the row data so checkboxes can work
        setRowData(hits.map((hit) => ({ ...hit._source, _id: hit._id })));
      } else {
        // If input (search term) was used and no results were found, update state to skip GSTIN for the next search
        if (input) {
          setSkipGSTIN(true);
        }
        setRowData([]);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  /** Delete a document from Elasticsearch by index and _id. Uses same ES base URL as fetch. */
  const deleteFromElasticsearch = async (index, documentId) => {
    if (!documentId) return;
    const esUrl = "https://dev-elastic.finkraftai.com";
    try {
      await axios.delete(`${esUrl}/${index}/_doc/${documentId}`);
    } catch (error) {
      console.error(`Error deleting from Elasticsearch (${index}):`, error);
      messageApi.open({
        type: "warning",
        content: `Document saved but failed to remove row from Elasticsearch: ${error?.response?.data?.message || error.message}`,
        duration: 4,
      });
    }
  };

  const fetchBookingElasticMatches = async (input = "") => {
    const scroll_time = "2m"
    const batch_size = 50
    const esUrl =
      "https://dev-elastic.finkraftai.com";

    let queryParts = [];
    const headers = {
      'Content-Type': 'application/json',
    };
    // Include GSTINs only if skipGSTIN is false
    if (!skipGSTIN) {
      if (hotelGSTIN) {
        queryParts.push(`${hotelGSTIN}`);
      } else if (matchDocument?.hotel_gstin) {
        queryParts.push(`${matchDocument?.hotel_gstin}`);
      }

      if (clientGSTIN) {
        queryParts.push(`${clientGSTIN}`);
      } else if (matchDocument?.guest_gstin) {
        queryParts.push(`${matchDocument?.guest_gstin}`);
      }
    }
    // Process user input from search bar (e.g. invoice number) — wrap with *term* for wildcard; GSTINs stay as-is
    const userQueries = input
      .split(",")
      .map((term) => term.trim())
      .filter((term) => term);

    if (userQueries.length > 0) {
      queryParts = queryParts.concat(userQueries.map((term) => `*${term}*`));
    }
    // Construct the final query string
    const queryStr = queryParts.length ? queryParts.join(" AND ") : "";

    const searchQuery = {
      size: batch_size,
      query: {
        query_string: {
          query: queryStr,
          fields: ["*"],
          default_operator: "AND",
          analyze_wildcard: true,
          fuzziness: "AUTO",
          lenient: true
        }
      },
      sort: [{ _score: { order: "desc" } }]
    };


    try {

      const response = await axios.post(
        `${esUrl}/hotel_booking_data/_search?scroll=${scroll_time}`,
        searchQuery, // ✅ This goes into the body
        { headers }
      );
      const hits = response.data?.hits.hits || [];
      if (hits.length > 0) {
        // Include _id in the row data so checkboxes can work
        setBookingRowData(hits.map((hit) => ({ ...hit._source, _id: hit._id })));
      } else {
        // If input (search term) was used and no results were found, update state to skip GSTIN for the next search
        if (input) {
          setSkipGSTIN(true);
        }
        setBookingRowData([]);
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };




  const handlePopulateClientDetails = async (gstinNumber) => {
    setClientLoading(true);
    if (validateGSTIN(gstinNumber)) {
      setClientEnteredGSTIN(gstinNumber);
      const response = await axios.post(
        "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/clientgstin/info",
        {
          gstin: gstinNumber,
        }
      );
      if (response.status && (response.data.data !== null && response.data.data.length > 0)) {
        setEnableClientGSTIN(false)
        setClientGSTIN(gstinNumber);
        setClientWorkspace(response.data.data?.[0]?.name);
        setWorkspaceStatusTag("Validate");
      } else {
        setWorkspaceStatusTag("GSTIN not found in DB");
        setEnableClientGSTIN(true)
        messageApi.open({
          type: "error",
          content: "No GSTIN found",
        });
      }
    } else {
      messageApi.open({
        type: "error",
        content: "Enter valid GSTIN"
      })
    }
    setClientLoading(false);
  };

  const handlePopulateHotelDetails = async (gstinNumber) => {
    setHotelLoading(true);
    if (validateGSTIN(gstinNumber)) {
      setHotelEnteredGSTIN(gstinNumber);
      const response = await axios.post(
        "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/hotelgstin/info",
        {
          gstin: gstinNumber,
        }
      );
      if (response.status && response.data.data !== null) {
        setHotelGSTIN(gstinNumber);
        setEnableHotelCreate(false);
        setHotelName(response.data.data["Hotel Name"]);
        setHotelStatusTag("Validated")
      } else {
        setHotelStatusTag("GSTIN not found in db")
        setEnableHotelCreate(true)
        messageApi.open({
          type: "error",
          content: "Hotel details could not found",
        });
      }
    }
    else {
      messageApi.open({
        type: "error",
        content: "Enter valid GSTIN"
      })
    }
    setHotelLoading(false);
  };


  const handleCreateHotelWithGstin = async () => {
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/hotel/create",
      {
        gstin: hotelEnteredGSTIN,
        hotel_name: matchDocument?.mapped_invoice_data?.hotel_name,
        tobescraped: true,
      }
    );
    if (response.status && response.data.data !== null) {
      messageApi.open({
        type: "success",
        content: "Hotel Created Successfully",
      });
      setEnableHotelCreate(false);
      setHotelGSTIN(hotelEnteredGSTIN);
      setHotelName(matchDocument?.hotel_name);
    } else {
      messageApi.open({
        type: "error",
        content: "Workspace details could not found",
      });
    }
  };

  // Debounced version of fetchUsers
  // const debouncedFetchUsers = useCallback(
  //   debounce(fetch2bmatchsElastic, 300),
  //   []
  // );

  // const handleInputChange = (event) => {
  //   const inputValue = event.target.value;
  //   debouncedFetchUsers(inputValue);
  // };

  const handleSaveCollection = async () => {
    // Validate all fields before saving
    const isValid = validateAllFields();
    if (!isValid) {
      messageApi.open({
        type: "error",
        content: "Please fill all required fields before saving",
        duration: 3,
      });
      return;
    }

    const payload = {
      documentId: document_id || documentId,
      two_b_data: selected2BMatch || null,
      booking_match: selectedBookingMatch || null,
      // Food_996332_amount: parseInt(validatedHSN332Amount),
      total_tax_amount: validatedGSTAmount,
      invoice_amount: validatedInvoiceAmount,
      // workspace: clientWorkspace || matchDocument?.validated_data?.workspace,
      guest_gstin:
        clientGSTIN || matchDocument?.guest_gstin,
      hotel_name: hotelName || matchDocument?.hotel_name,
      hotel_gstin:
        hotelGSTIN || matchDocument?.hotel_gstin,
      invoice_number: invoiceNumber || matchDocument?.invoice_number,
      selected_issue: selectedIssue,
      invoice_date: validatedInvoiceDate || matchDocument?.invoice_date,
      remarks: remarks,
      attachment_url: attachment_url,
      message_date: message_date,
      assetLink: assetLink,
      // Include all dynamic field values from "Show More" (mandatory second input box)
      // Exclude problematic fields that cause MongoDB conflicts
      ...Object.fromEntries(
        Object.entries(dynamicFieldOutputValues).filter(([key]) =>
          key !== "No" && !key.startsWith("No.")
        )
      ),
    };
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/update",
      // "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/update",
      payload
    );
    if (response.status) {
      // Delete selected row(s) from Elasticsearch (same ES URL as fetch, DELETE by _id)
      const deletePromises = [];
      if (selected2BMatch?._id) {
        deletePromises.push(deleteFromElasticsearch("hotel_za_master_data", selected2BMatch._id));
      }
      if (selectedBookingMatch?._id) {
        deletePromises.push(deleteFromElasticsearch("hotel_booking_data", selectedBookingMatch._id));
      }
      if (deletePromises.length > 0) {
        await Promise.all(deletePromises);
      }
      messageApi.open({
        type: "success",
        content: "Document saved successfully",
        duration: 2,
      });
      // DO NOT reset checkbox selections here - they will be reset when fetchDocument loads new document
      setIsNonInvoice(false);
      setEnableHotelCreate("")
      setEnableClientGSTIN("")
      setHotelEnteredGSTIN("");
      setHotelGSTIN("");
      setHotelName("");
      setClientEnteredGSTIN("");
      setClientWorkspace("");
      setClientWorkspace("");
      setValidatedGSTAmount("");
      setValidatedHSN332Amount("");
      setValidatedInvoiceAmount("");
      setRemarks("");
      setSelectedIssue("");
      setInvoiceNumber("")
      setValidatedInvoiceDate("")
      setDynamicFieldValues({}); // Reset dynamic field values
      setDynamicFieldInputValues({}); // Reset first input box values
      setDynamicFieldOutputValues({}); // Reset second input box values
      setAttachment_url(null)
      setMessage_date("")
      // Preserve filter when saving - apply same filter to next document
      if (filterType !== "All" && filterValue) {
        const filterParams = {
          type: filterType,
          value: filterValue,
        };
        // Add PAN numbers if client_name filter is active
        if (filterType === "client_name" && currentFilterPanNumbers.length > 0) {
          filterParams.pan_numbers = currentFilterPanNumbers;
        }
        // Add GSTIN numbers if client_gstin or hotel_gstin filter is active
        if ((filterType === "client_gstin" || filterType === "hotel_gstin") && currentFilterGstinNumbers.length > 0) {
          filterParams.gstin_numbers = currentFilterGstinNumbers;
        }
        fetchDocument(filterParams);
      } else {
        fetchDocument();
      }
    }
  };

  const handleSkipDocument = async () => {
    const response = await axios.post(
      // "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/skip/" +
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/match_document/skip/" +
      document_id
    );
    if (response.status) {
      setEnableHotelCreate("")
      setEnableClientGSTIN("")
      setWorkspaceStatusTag("");
      setHotelStatusTag("");
      setParsedStatusTag("");
      setHotelEnteredGSTIN("");
      setHotelGSTIN("");
      setHotelName("");
      setClientGSTIN(""); // Clear first input box
      setClientEnteredGSTIN(""); // Clear second input box
      setClientWorkspace("");
      setClientWorkspace("");
      setValidatedGSTAmount("");
      setValidatedHSN332Amount("");
      setValidatedInvoiceAmount("");
      setInvoiceNumber("")
      setRemarks("");
      setSelectedIssue("");
      setSelected2BMatch(null);
      setSelectedBookingMatch(null);
      setAmount996331("")
      setAmount996334("")
      setAmount996339("")
      setAmount996311("")
      setInvoiceNumber("")

      // Preserve filter when skipping - apply same filter to next document
      if (filterType !== "All" && filterValue) {
        const filterParams = {
          type: filterType,
          value: filterValue,
        };
        // Add PAN numbers if client_name filter is active
        if (filterType === "client_name" && currentFilterPanNumbers.length > 0) {
          filterParams.pan_numbers = currentFilterPanNumbers;
        }
        // Add GSTIN numbers if client_gstin or hotel_gstin filter is active
        if ((filterType === "client_gstin" || filterType === "hotel_gstin") && currentFilterGstinNumbers.length > 0) {
          filterParams.gstin_numbers = currentFilterGstinNumbers;
        }
        fetchDocument(filterParams);
      } else {
        fetchDocument();
      }
    }
  };

  const handleRedirectToCRM = async (gstinNumber) => {
    const response = await axios.get(
      "https://stage-apiplatform.finkraftai.com/api/fuzzy/hotelInfo/" + gstinNumber
    );
    if (response.status) {
      window.open(
        "https://crm.zoho.in/crm/org60016690758/tab/Accounts/" +
        response.data.data.zoho_crm_id
      );
    }
  };


  const handleCopyData = (copyText, isDate = false) => {
    let textToCopy = copyText;
    if (isDate) {
      textToCopy = moment(copyText).format("DD-MM-YYYY");
    }
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          console.log("Text copied to clipboard");
          messageApi.success({
            type: "success",
            content: "Copied",
          });
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      // Clipboard API not supported, fallback to older method
      fallbackCopyTextToClipboard(textToCopy);
    }
  };

  function fallbackCopyTextToClipboard(text) {
    // Create a temporary textarea element
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      // Execute the copy command
      document.execCommand("copy");
   
      messageApi.success({
        type: "success",
        content: "Copied",
      });
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }

    // Remove the temporary textarea element
    document.body.removeChild(textArea);
  }


  const handleWorkspaceChange = (newData, type) => {
    if (type === "workspace") {
      setWorkspaceStatusTag("Validated");
    } else if (type === "hotel") {
      setHotelStatusTag("Validated");
    }
    else if (type === "parsed") {
      setParsedStatusTag("Validated")
    }
  };


  const handleKeyDown = (e, sectionKey) => {
    if (e.key === "ArrowDown") {
      const nextKey = getNextSectionKey(sectionKey);
      sectionRefs[nextKey]?.current?.focus();  // Focus on the next section
    } else if (e.key === "ArrowUp") {
      const prevKey = getPrevSectionKey(sectionKey);
      sectionRefs[prevKey]?.current?.focus();  // Focus on the previous section
    }
  };

  const getNextSectionKey = (currentKey) => {
    const sectionKeys = ["1", "2", "3", "4", "5"];
    const currentIndex = sectionKeys.indexOf(currentKey);
    return sectionKeys[(currentIndex + 1) % sectionKeys.length];  // Wrap around if necessary
  };

  const getPrevSectionKey = (currentKey) => {
    const sectionKeys = ["1", "2", "3", "4", "5"];
    const currentIndex = sectionKeys.indexOf(currentKey);
    return sectionKeys[(currentIndex - 1 + sectionKeys.length) % sectionKeys.length];  // Wrap around if necessary
  };




  const handleCollapseChange = (key) => {
    // Retain the original functionality to focus on the section container
    if (key === "1") {
      sectionRefs["1"]?.current?.focus();
      // Fetch client list when client section is opened
      if (clientList.length === 0) {
        fetchClientInfoByPan();
      }
    } else if (key === "2") {
      sectionRefs["2"]?.current?.focus();
    } else if (key === "3") {
      sectionRefs["3"]?.current?.focus();
    } else if (key === "4") {
      sectionRefs["4"]?.current?.focus();
    } else if (key === "5") {
      sectionRefs["5"]?.current?.focus();
    }
  };

  const handleFieldKeyDown = (e, sectionKey) => {
    // Hardcoded refs for each section using numeric keys like "11", "12", etc.
    const sectionInputs = {
      "1": [
        sectionRefs["11"],
        sectionRefs["12"],
        sectionRefs["13"],
        sectionRefs["14"],
        sectionRefs["15"],
        sectionRefs["16"],
        sectionRefs["17"],
        sectionRefs["18"],
        sectionRefs["19"]
      ],  // Inputs and div for section 1

      "2": [

        sectionRefs["21"],
        sectionRefs["22"],
        sectionRefs["23"],
        sectionRefs["24"],
        sectionRefs["25"],
        sectionRefs["26"],
        sectionRefs["27"],
        sectionRefs["28"],
        sectionRefs["29"],
        sectionRefs["30"]
      ],

      "3": [
        sectionRefs["31"],
        sectionRefs["32"],
        sectionRefs["33"],
        sectionRefs["34"],
        sectionRefs["35"],
        sectionRefs["36"],
        sectionRefs["37"],
        sectionRefs["38"],
        sectionRefs["39"],
        sectionRefs["311"],
        sectionRefs["312"],
        sectionRefs["313"],
        sectionRefs["314"],
        sectionRefs["315"],
        sectionRefs["316"],
        sectionRefs["317"],
        sectionRefs["318"],
        sectionRefs["319"],
        sectionRefs["320"],
        sectionRefs["321"],
        sectionRefs["322"],
        sectionRefs["323"],
        sectionRefs["324"],
        sectionRefs["325"],
        sectionRefs["326"],
        sectionRefs["327"],
        sectionRefs["328"],
        sectionRefs["329"],
        sectionRefs["330"],
        sectionRefs["331"],
        sectionRefs["332"],
        sectionRefs["333"],
        sectionRefs["334"],
        sectionRefs["335"],
        sectionRefs["336"],
        sectionRefs["337"],
        sectionRefs["338"],


      ],

      // Add other sections with their inputRefs and divRefs here as needed
      "4": [

        sectionRefs["41"],
        sectionRefs["42"]
      ],
      "5": [

        sectionRefs["51"],

      ],
    };

    // Get the currently focused element in the section
    const sectionInputArray = sectionInputs[sectionKey];
    const currentIndex = sectionInputArray.findIndex(
      (ref) => ref?.current === document.activeElement
    );

    if (e.key === "Enter") {
      const focusedElement = document.activeElement;

      if (focusedElement) {
        // ✅ Trigger the onClick event of the focused element
        focusedElement.click();
      }
      if (e.key === "Tab" && e.shiftKey) {
        if (currentIndex > 0) {
          // Focus on the previous field
          const previousField = sectionInputArray[currentIndex - 1];
          previousField?.current?.focus();
        } else {
          // Optionally, handle the case where you are at the first input
          // (for example, focus on the last field of the section or move to the previous section)
          // Uncomment and adjust as needed.
          // sectionInputArray[sectionInputArray.length - 1]?.current?.focus();
        }
      }


    }


  };

  const sectionRefs = {
    "1": useRef(),
    "2": useRef(),
    "3": useRef(),
    "4": useRef(),
    "5": useRef(),
    "11": useRef(),
    "12": useRef(),
    "13": useRef(),
    "14": useRef(),
    "15": useRef(),
    "16": useRef(),
    "17": useRef(),
    "18": useRef(),
    "19": useRef(),



  };




  const items = [
    {
      key: "1",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}
          ref={sectionRefs["1"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "1")}>
          <div style={{ width: "50%" }}>Client Detail</div>
          <div style={{ width: "30%" }}>
            {/* <Tag color="green" icon={<CheckOutlined />}>
              Status
            </Tag> */}
            <Tag color={workspaceStatusTag === "Validated" ? "green" : "red"} >
              {workspaceStatusTag}
            </Tag>
          </div>
        </div>
      ),
      children: (
        <div style={{ width: "100%" }} >

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["16"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "1")}>Client GSTIN</div>
            <div
              style={{ width: "33%", display: "flex", alignItems: "center" }}
            >
              <Input
                ref={sectionRefs["17"]}
                tabIndex={0}
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                size="small"
                placeholder="Client GSTIN"
                style={{ width: 200 }}
                suffix={clientLoading ? <LoadingOutlined /> : null}
                value={clientGSTIN || matchDocument?.guest_gstin || ""}
                onChange={(e) => {
                  setClientGSTIN(e.target.value);
                }}
              />

              <CopyOutlined
                style={{ marginLeft: 24, cursor: "pointer" }}
                ref={sectionRefs["18"]}
                tabIndex={0}
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                onClick={() => handleCopyData(matchDocument?.guest_gstin)}
              />
              <ArrowRightOutlined
                ref={sectionRefs["19"]}
                tabIndex={0}
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const gstinValue = clientGSTIN || matchDocument?.guest_gstin || "";
                  if (gstinValue && gstinValue.trim()) {
                    setClientEnteredGSTIN(gstinValue.trim());
                    fetch2bmatchsElastic(gstinValue.trim());
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["20"]}
                tabIndex={0}
                onKeyDown={(e) => handleFieldKeyDown(e, "1")}
                size="small"
                placeholder="Client GSTIN"
                style={{
                  width: 200,
                  borderColor: validationErrors.clientGSTIN ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.clientGSTIN ? "2px" : undefined
                }}
                value={clientEnteredGSTIN}
                onChange={(e) => {
                  setClientEnteredGSTIN(e.target.value);
                }}
                onPressEnter={(e) => {
                  const value = e.target.value.trim();
                  if (value) {
                    setClientEnteredGSTIN(value);
                    fetch2bmatchsElastic(value);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value.trim();
                  if (value) {
                    setClientEnteredGSTIN(value);
                    fetch2bmatchsElastic(value);
                  }
                  validateAllFields();
                }}
                required
                disabled
              />
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}
          ref={sectionRefs["2"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "2")}>
          <div style={{ width: "50%" }}  >Hotel Detail</div>
          <div style={{ width: "30%" }}>
            {/* <Tag color="green" icon={<CheckOutlined />}>
              Status
            </Tag> */}
            <Tag color={hotelStatusTag === "Validated" ? "green" : "red"} >
              {hotelStatusTag}
            </Tag>
          </div>
          <div
            style={{
              width: "10%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >

          </div>
        </div>
      ),
      children: (
        <div style={{ width: "100%" }}>
          <div style={{ widht: "100%", display: "flex", alignItems: "center" }}>
            <div style={{ width: "33%" }} ref={sectionRefs["21"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}>Hotel Name</div>
            <div style={{ width: "33%", display: "flex", alignItems: "center" }}>
              <Input
                ref={sectionRefs["22"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                size="small"
                placeholder="Hotel Name"
                style={{ width: 200 }}
                value={hotelNameInput || matchDocument?.hotel_name || ""}
                onChange={(e) => setHotelNameInput(e.target.value)}
              />
              <CopyOutlined
                ref={sectionRefs["23"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                style={{ marginLeft: 24, cursor: "pointer" }}
                onClick={() => handleCopyData(matchDocument?.hotel_name)}
              />
              <ArrowRightOutlined
                ref={sectionRefs["24"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const hotelNameValue = hotelNameInput || matchDocument?.hotel_name || "";
                  const hotelNameStr = String(hotelNameValue || "").trim();
                  if (hotelNameStr) {
                    setHotelName(hotelNameStr);
                    handleWorkspaceChange(hotelNameStr, "hotel");
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["25"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                size="small"
                placeholder="Hotel Name"
                value={hotelName}
                onChange={(e) => setHotelName(e.target.value)}
                onBlur={() => validateAllFields()}
                disabled
                style={{
                  borderColor: validationErrors.hotelName ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.hotelName ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>

          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["26"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}>Hotel GSTIN</div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["27"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                size="small"
                placeholder="Hotel GSTIN"
                style={{ width: 200 }}
                value={hotelGSTINInput || matchDocument?.hotel_gstin || ""}
                onChange={(event) => {
                  setHotelGSTINInput(event.target.value);
                }}
                suffix={hotelLoading ? <LoadingOutlined /> : null}
              />
              <CopyOutlined style={{ marginLeft: 24 }} ref={sectionRefs["28"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                onClick={() =>
                  handleCopyData(matchDocument?.hotel_gstin)
                } />
              <ArrowRightOutlined
                ref={sectionRefs["29"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const gstinValue = hotelGSTINInput || matchDocument?.hotel_gstin || "";
                  const gstinValueStr = String(gstinValue || "").trim();
                  if (gstinValueStr) {
                    setHotelGSTIN(gstinValueStr);
                    fetch2bmatchsElastic();
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>

              <Input
                ref={sectionRefs["30"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "2")}
                size="small"
                placeholder="Hotel GSTIN"
                value={hotelGSTIN}
                // onChange={(e) => setHotelGSTIN(e.target.value)}
                onBlur={() => validateAllFields()}
                style={{
                  borderColor: validationErrors.hotelGSTIN ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.hotelGSTIN ? "2px" : undefined
                }}
                required
                disabled
              />

            </div>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }} ref={sectionRefs["3"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "3")}>
          <div style={{ width: "50%" }}>Parsed data from Invoice</div>
          <div style={{ width: "30%" }}>
            <Tag color={parsedStatusTag === "Validated" ? "green" : "red"} >
              {parsedStatusTag}
            </Tag>
          </div>
        </div>
      ),
      children: (
        <div style={{ width: "100%" }}>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["325"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>GST Amount</div>
            <div style={{ width: "33%", display: "flex", alignItems: "center" }}>
              <Input
                ref={sectionRefs["326"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="GST Amount"
                style={{ width: 200 }}
                value={gstAmountInput || matchDocument?.total_tax_amount || ""}
                onChange={(e) => setGstAmountInput(e.target.value)}
              />
              <CopyOutlined
                ref={sectionRefs["327"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer" }}
                onClick={() => handleCopyData(matchDocument?.total_tax_amount)}
              />
              <ArrowRightOutlined
                ref={sectionRefs["328"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const gstValue = gstAmountInput || matchDocument?.total_tax_amount || "";
                  const gstValueStr = String(gstValue || "").trim();
                  if (gstValueStr) {
                    setValidatedGSTAmount(gstValueStr);
                    handleWorkspaceChange(gstValueStr, "parsed");
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["329"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="GST Amount"
                value={validatedGSTAmount}
                onChange={(event) => setValidatedGSTAmount(event.target.value)}
                onBlur={() => validateAllFields()}
                disabled
                style={{
                  borderColor: validationErrors.gstAmount ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.gstAmount ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["330"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>Invoice Number</div>
            <div style={{ width: "33%", display: "flex", alignItems: "center" }}>
              <Input
                ref={sectionRefs["330"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Number"
                style={{ width: 200 }}
                value={invoiceNumberInput || matchDocument?.invoice_number || ""}
                onChange={(e) => setInvoiceNumberInput(e.target.value)}
              />
              <CopyOutlined
                ref={sectionRefs["331"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer" }}
                onClick={() => handleCopyData(matchDocument?.invoice_number)}
              />
              <ArrowRightOutlined
                ref={sectionRefs["332"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const invoiceNumValue = invoiceNumberInput || matchDocument?.invoice_number || "";
                  const invoiceNumStr = String(invoiceNumValue || "").trim();
                  if (invoiceNumStr) {
                    setInvoiceNumber(invoiceNumStr);
                    handleWorkspaceChange(invoiceNumStr, "parsed");
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["333"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Number"
                value={invoiceNumber}
                onChange={(event) => setInvoiceNumber(event.target.value)}
                onBlur={() => validateAllFields()}
                disabled
                style={{
                  borderColor: validationErrors.invoiceNumber ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.invoiceNumber ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["334"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>Invoice Amount</div>
            <div style={{ width: "33%", display: "flex", alignItems: "center" }}>
              <Input
                ref={sectionRefs["335"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Amount"
                style={{ width: 200 }}
                value={invoiceAmountInput || matchDocument?.invoice_amount || ""}
                onChange={(e) => setInvoiceAmountInput(e.target.value)}
              />
              <CopyOutlined
                ref={sectionRefs["336"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer" }}
                onClick={() => handleCopyData(matchDocument?.invoice_amount)}
              />
              <ArrowRightOutlined
                ref={sectionRefs["337"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const invoiceAmtValue = invoiceAmountInput || matchDocument?.invoice_amount || "";
                  const invoiceAmtStr = String(invoiceAmtValue || "").trim();
                  if (invoiceAmtStr) {
                    setValidatedInvoiceAmount(invoiceAmtStr);
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["338"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Amount"
                value={validatedInvoiceAmount}
                onChange={(event) =>
                  setValidatedInvoiceAmount(event.target.value)
                }
                onBlur={() => validateAllFields()}
                disabled
                style={{
                  borderColor: validationErrors.invoiceAmount ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.invoiceAmount ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>
          <div
            style={{
              widht: "100%",
              display: "flex",
              alignItems: "center",
              marginTop: 12,
            }}
          >
            <div style={{ width: "33%" }} ref={sectionRefs["339"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}>Invoice Date</div>
            <div style={{ width: "33%", display: "flex", alignItems: "center" }}>
              <Input
                ref={sectionRefs["340"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Date"
                style={{ width: 200 }}
                value={invoiceDateInput || matchDocument?.invoice_date || ""}
                onChange={(e) => setInvoiceDateInput(e.target.value)}
              />
              <CopyOutlined
                ref={sectionRefs["341"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer" }}
                onClick={() => handleCopyData(matchDocument?.invoice_date)}
              />
              <ArrowRightOutlined
                ref={sectionRefs["342"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                style={{ marginLeft: 24, cursor: "pointer", color: "#0A8394" }}
                onClick={() => {
                  const invoiceDateValue = invoiceDateInput || matchDocument?.invoice_date || "";
                  const invoiceDateStr = String(invoiceDateValue || "").trim();
                  if (invoiceDateStr) {
                    setValidatedInvoiceDate(invoiceDateStr);
                  }
                }}
              />
            </div>
            <div style={{ width: "33%" }}>
              <Input
                ref={sectionRefs["343"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
                size="small"
                placeholder="Invoice Date"
                value={validatedInvoiceDate}
                onChange={(event) =>
                  setValidatedInvoiceDate(event.target.value)
                }
                onBlur={() => validateAllFields()}
                disabled
                style={{
                  borderColor: validationErrors.invoiceDate ? "rgb(236 158 159)" : undefined,
                  borderWidth: validationErrors.invoiceDate ? "2px" : undefined
                }}
                required
              />
            </div>
          </div>

          {/* Show More Button */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: 12,
            }}
          >
            <Button
              type="link"
              onClick={() => setShowMoreParsedData(!showMoreParsedData)}
            >
              {showMoreParsedData ? "Show Less" : "Show More"}
            </Button>
          </div>

          {/* Dynamically rendered additional fields */}
          {showMoreParsedData && matchDocument && (
            <>
              {Object.entries(matchDocument).map(([key, value]) => {
                // Skip already displayed fields
                const excludedFields = [
                  'total_tax_amount',
                  'invoice_number',
                  'invoice_amount',
                  'invoice_date',
                  'guest_gstin',
                  'hotel_gstin',
                  'hotel_name'
                ];

                if (excludedFields.includes(key)) {
                  return null;
                }

                // Format field name (convert snake_case to Title Case)
                const formatFieldName = (str) => {
                  return str
                    .split('_')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
                };

                // Check if value is an object or array
                const isObjectOrArray = value !== null && typeof value === 'object';

                // Convert value to display string
                const getDisplayValue = (val) => {
                  if (val === null || val === undefined) return "-";
                  if (isObjectOrArray) {
                    return JSON.stringify(val, null, 2);
                  }
                  return String(val);
                };

                // Check if field exists in original document
                const fieldExists = value !== null && value !== undefined;

                // Get the first input value (from state or original document value)
                // Handle 0, [], and "" as valid values (don't convert them)
                const getFirstInputDefault = () => {
                  if (!fieldExists) return "";
                  if (isObjectOrArray) {
                    // Handle empty arrays as valid - show as "[]"
                    if (Array.isArray(value) && value.length === 0) return "[]";
                    return JSON.stringify(value, null, 2);
                  }
                  // For numbers, preserve 0 as valid value
                  if (typeof value === 'number') return String(value);
                  // For strings, preserve empty string "" as valid value
                  if (typeof value === 'string') return value; // This includes "" as valid
                  // For other types, convert to string or empty string
                  return value !== null && value !== undefined ? String(value) : "";
                };
                const firstInputValue = dynamicFieldInputValues[key] !== undefined
                  ? dynamicFieldInputValues[key]
                  : getFirstInputDefault();

                // Get the second input value (auto-populated for Show More fields)
                const secondInputValue = dynamicFieldOutputValues[key] !== undefined
                  ? dynamicFieldOutputValues[key]
                  : "";

                // Handle first input value change
                const handleFirstInputChange = (newValue) => {
                  setDynamicFieldInputValues(prev => ({
                    ...prev,
                    [key]: newValue
                  }));
                };

                // Handle second input value change
                const handleSecondInputChange = (newValue) => {
                  if (isObjectOrArray) {
                    // Try to parse JSON, if fails keep as string
                    try {
                      const parsed = JSON.parse(newValue);
                      // Handle empty array [] - it's a valid value
                      setDynamicFieldOutputValues(prev => ({
                        ...prev,
                        [key]: parsed
                      }));
                      setDynamicFieldValues(prev => ({
                        ...prev,
                        [key]: parsed
                      }));
                    } catch (e) {
                      // Invalid JSON or empty array string "[]"
                      if (newValue.trim() === "[]") {
                        // Explicitly handle empty array
                        setDynamicFieldOutputValues(prev => ({
                          ...prev,
                          [key]: []
                        }));
                        setDynamicFieldValues(prev => ({
                          ...prev,
                          [key]: []
                        }));
                      } else {
                        // Invalid JSON, store as string temporarily
                        setDynamicFieldOutputValues(prev => ({
                          ...prev,
                          [key]: newValue
                        }));
                        setDynamicFieldValues(prev => ({
                          ...prev,
                          [key]: newValue
                        }));
                      }
                    }
                  } else {
                    // For non-object/array values, preserve type
                    let processedValue = newValue;
                    if (typeof value === 'number') {
                      // Try to parse as number, preserve 0
                      const numValue = newValue === "" ? null : (isNaN(Number(newValue)) ? newValue : Number(newValue));
                      processedValue = numValue;
                    } else if (typeof value === 'string') {
                      // Preserve empty string "" as valid value
                      processedValue = newValue; // Keep as string, including ""
                    }
                    setDynamicFieldOutputValues(prev => ({
                      ...prev,
                      [key]: processedValue
                    }));
                    setDynamicFieldValues(prev => ({
                      ...prev,
                      [key]: processedValue
                    }));
                  }
                };

                return (
                  <div
                    key={key}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: isObjectOrArray ? "flex-start" : "center",
                      marginTop: 12,
                    }}
                  >
                    <div style={{ width: "33%", paddingTop: isObjectOrArray ? 8 : 0 }}>{formatFieldName(key)}</div>
                    <div style={{ width: "33%", display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                      {isObjectOrArray ? (
                        <TextArea
                          size="small"
                          placeholder={formatFieldName(key)}
                          style={{ width: 200, fontFamily: "monospace", fontSize: 12 }}
                          value={typeof firstInputValue === 'string' ? firstInputValue : JSON.stringify(firstInputValue, null, 2)}
                          onChange={(e) => handleFirstInputChange(e.target.value)}
                          rows={4}
                        />
                      ) : (
                        <Input
                          size="small"
                          placeholder={formatFieldName(key)}
                          style={{ width: 200 }}
                          value={firstInputValue}
                          onChange={(e) => handleFirstInputChange(e.target.value)}
                        />
                      )}
                      <CopyOutlined
                        style={{
                          marginLeft: 24,
                          cursor: fieldExists ? "pointer" : "not-allowed",
                          opacity: fieldExists ? 1 : 0.5
                        }}
                        onClick={() => {
                          if (fieldExists) {
                            handleCopyData(isObjectOrArray ? JSON.stringify(value, null, 2) : value);
                          }
                        }}
                      />
                      <ArrowRightOutlined
                        style={{
                          marginLeft: 24,
                          // Allow arrow if field exists and firstInputValue is not null/undefined (including 0, [], and "")
                          cursor: fieldExists && (firstInputValue !== null && firstInputValue !== undefined) ? "pointer" : "not-allowed",
                          color: fieldExists && (firstInputValue !== null && firstInputValue !== undefined) ? "#0A8394" : "#ccc",
                          opacity: fieldExists && (firstInputValue !== null && firstInputValue !== undefined) ? 1 : 0.5
                        }}
                        onClick={() => {
                          // Allow click if field exists and firstInputValue is not null/undefined (including 0, [], and "")
                          if (fieldExists && (firstInputValue !== null && firstInputValue !== undefined)) {
                            let valToSet = firstInputValue;
                            // If firstInputValue is empty string, use original value (which might also be "")
                            if (firstInputValue === "" && value === null) {
                              // If original value is null, don't set anything
                              return;
                            }
                            if (firstInputValue === "" && value === undefined) {
                              // If original value is undefined, don't set anything
                              return;
                            }
                            // Handle object/array values
                            if (isObjectOrArray) {
                              // Handle empty arrays
                              if (Array.isArray(value) && value.length === 0) {
                                valToSet = "[]";
                              } else {
                                valToSet = JSON.stringify(value, null, 2);
                              }
                            } else if (firstInputValue === "" && typeof value === 'string' && value === "") {
                              // If both are empty strings, preserve the empty string
                              valToSet = "";
                            } else if (firstInputValue === "" && value !== null && value !== undefined) {
                              valToSet = String(value);
                            }
                            handleSecondInputChange(String(valToSet));
                          }
                        }}
                      />
                    </div>
                    <div style={{ width: "33%" }}>
                      {isObjectOrArray ? (
                        <TextArea
                          size="small"
                          placeholder={formatFieldName(key)}
                          value={
                            typeof secondInputValue === 'string'
                              ? secondInputValue
                              : (Array.isArray(secondInputValue) && secondInputValue.length === 0
                                ? "[]"
                                : JSON.stringify(secondInputValue, null, 2))
                          }
                          onChange={(e) => handleSecondInputChange(e.target.value)}
                          onBlur={() => validateAllFields()}
                          rows={4}
                          style={{
                            fontFamily: "monospace",
                            fontSize: 12
                          }}
                        />
                      ) : (
                        <Input
                          size="small"
                          placeholder={formatFieldName(key)}
                          value={secondInputValue !== null && secondInputValue !== undefined ? String(secondInputValue) : ""}
                          onChange={(e) => handleSecondInputChange(e.target.value)}
                          onBlur={() => validateAllFields()}
                          disabled
                        />
                      )}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      ),
    },


    {
      key: "4",
      // label: "GST 2B data Matches",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }} ref={sectionRefs["4"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "4")}>
          <div style={{ width: "50%" }}>Hotel ZA Matches</div>
          <div style={{ width: "30%" }}>

          </div>
        </div>
      ),
      children: (
        <div >
          <div style={{ width: "100%", marginBottom: 12 }}>
            <Input
              ref={sectionRefs["41"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
              placeholder="Search "
              style={{ width: 300 }}
              onChange={(event) => { setSkipGSTIN(true); fetch2bmatchsElastic(event.target.value) }}
            />
          </div>
          <div style={{ height: 300 }} className="ag-theme-alpine">
            <AgGridReact
              columnDefs={twoBGridColumnDefs}
              rowData={rowData}
              overlayNoRowsTemplate="No rows to show"
            />
          </div>
        </div>
      ),
    },
    {
      key: "5",
      // label: "Booking details",
      label: (
        <div style={{ width: "100%", display: "flex", alignItems: "center" }}
          ref={sectionRefs["5"]}
          tabIndex={0}  // Make the section focusable
          onKeyDown={(e) => handleKeyDown(e, "5")}>
          <div style={{ width: "50%" }}>Booking details</div>

        </div>
      ),
      children: (
        <div>
          <div style={{ width: "100%", marginBottom: 12 }}>
            <Input
              ref={sectionRefs["42"]} tabIndex={0} onKeyDown={(e) => handleFieldKeyDown(e, "3")}
              placeholder="Search "
              style={{ width: 300 }}
              onChange={(event) => { setSkipGSTIN(true); fetchBookingElasticMatches(event.target.value) }}

            />
          </div>
          <div style={{ height: 300 }} className="ag-theme-alpine">
            <AgGridReact
              columnDefs={[
                {
                  headerName: "Select",
                  width: 80,
                  cellRenderer: (params) => {
                    // Get the document ID from the current row
                    const currentRowId = params.data?._id;
                    // Get the document ID from the selected match
                    const selectedRowId = selectedBookingMatch?._id;
                    // Check if this row is selected by comparing IDs
                    const isChecked = selectedBookingMatch !== null &&
                      currentRowId !== undefined &&
                      selectedRowId !== undefined &&
                      String(currentRowId) === String(selectedRowId);
                    return (
                      <Checkbox
                        checked={isChecked}
                        onChange={() => setSelectedBookingMatch(params.data)}
                      />
                    );
                  },
                },
                {
                  headerName: "Booking ID",
                  field: "email_bookingId",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.email_bookingId ||
                    params.data?._source?.email_bookingId,
                },
                {
                  headerName: "Sharable Booking ID",
                  field: "email_sharableBookingId",
                  filter: "agTextColumnFilter",
                  width: 180,
                  valueGetter: (params) =>
                    params.data?.email_sharableBookingId ||
                    params.data?._source?.email_sharableBookingId,
                },
                {
                  headerName: "Hotel Name",
                  field: "email_hotel_name",
                  filter: "agTextColumnFilter",
                  width: 200,
                  valueGetter: (params) =>
                    params.data?.email_hotel_name ||
                    params.data?._source?.email_hotel_name,
                },
                {
                  headerName: "Hotel Address",
                  field: "email_hotel_address",
                  filter: "agTextColumnFilter",
                  width: 250,
                  valueGetter: (params) =>
                    params.data?.email_hotel_address ||
                    params.data?._source?.email_hotel_address,
                },
                {
                  headerName: "Hotel City",
                  field: "email_hotel_city",
                  filter: "agTextColumnFilter",
                  width: 130,
                  valueGetter: (params) =>
                    params.data?.email_hotel_city ||
                    params.data?._source?.email_hotel_city,
                },
                {
                  headerName: "Hotel State",
                  field: "email_hotel_state",
                  filter: "agTextColumnFilter",
                  width: 130,
                  valueGetter: (params) =>
                    params.data?.email_hotel_state ||
                    params.data?._source?.email_hotel_state,
                },
                {
                  headerName: "Hotel GSTIN",
                  field: "email_hotel_gstin",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.email_hotel_gstin ||
                    params.data?._source?.email_hotel_gstin,
                },
                {
                  headerName: "Check-in Date",
                  field: "email_checkindate",
                  filter: "agTextColumnFilter",
                  width: 130,
                  valueGetter: (params) =>
                    params.data?.email_checkindate ||
                    params.data?._source?.email_checkindate,
                },
                {
                  headerName: "Booking Date",
                  field: "email_bookingdate",
                  filter: "agTextColumnFilter",
                  width: 130,
                  valueGetter: (params) =>
                    params.data?.email_bookingdate ||
                    params.data?._source?.email_bookingdate,
                },
                {
                  headerName: "Check-out Date",
                  field: "email_checkoutdate",
                  filter: "agTextColumnFilter",
                  width: 130,
                  valueGetter: (params) =>
                    params.data?.email_checkoutdate ||
                    params.data?._source?.email_checkoutdate,
                },
                {
                  headerName: "Hotel Contact Email",
                  field: "email_hotel_contact_email",
                  filter: "agTextColumnFilter",
                  width: 200,
                  valueGetter: (params) => {
                    const emails = params.data?.email_hotel_contact_email ||
                      params.data?._source?.email_hotel_contact_email;
                    return Array.isArray(emails) ? emails.join(", ") : emails;
                  },
                },
                {
                  headerName: "Hotel Contact Phone",
                  field: "email_hotel_contact_phone",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) => {
                    const phones = params.data?.email_hotel_contact_phone ||
                      params.data?._source?.email_hotel_contact_phone;
                    return Array.isArray(phones) ? phones.join(", ") : phones;
                  },
                },
                {
                  headerName: "Company Name",
                  field: "company_name",
                  filter: "agTextColumnFilter",
                  width: 200,
                  valueGetter: (params) =>
                    params.data?.company_name ||
                    params.data?._source?.company_name,
                },
                {
                  headerName: "Company GSTIN",
                  field: "gstin",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.gstin ||
                    params.data?._source?.gstin,
                },
                {
                  headerName: "Total GST",
                  field: "totalGST",
                  filter: "agNumberColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.totalGST ||
                    params.data?._source?.totalGST,
                },
                {
                  headerName: "Company Address",
                  field: "company_address",
                  filter: "agTextColumnFilter",
                  width: 250,
                  valueGetter: (params) =>
                    params.data?.company_address ||
                    params.data?._source?.company_address,
                },
                {
                  headerName: "First Name",
                  field: "firstName",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.firstName ||
                    params.data?._source?.firstName,
                },
                {
                  headerName: "Middle Name",
                  field: "middleName",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.middleName ||
                    params.data?._source?.middleName,
                },
                {
                  headerName: "Last Name",
                  field: "lastName",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.lastName ||
                    params.data?._source?.lastName,
                },
                {
                  headerName: "Traveller",
                  field: "Traveller",
                  filter: "agTextColumnFilter",
                  width: 180,
                  valueGetter: (params) =>
                    params.data?.Traveller ||
                    params.data?._source?.Traveller,
                },
                {
                  headerName: "Email",
                  field: "email",
                  filter: "agTextColumnFilter",
                  width: 200,
                  valueGetter: (params) =>
                    params.data?.email ||
                    params.data?._source?.email,
                },
                {
                  headerName: "Hotel Email Already Present",
                  field: "hotel_email_already_present",
                  filter: "agTextColumnFilter",
                  width: 200,
                  valueGetter: (params) =>
                    params.data?.hotel_email_already_present ||
                    params.data?._source?.hotel_email_already_present,
                },
                {
                  headerName: "GST Config",
                  field: "gstconfig",
                  filter: "agTextColumnFilter",
                  width: 120,
                  valueGetter: (params) =>
                    params.data?.gstconfig ||
                    params.data?._source?.gstconfig,
                },
                {
                  headerName: "Booking Client ID",
                  field: "booking_client_id",
                  filter: "agTextColumnFilter",
                  width: 200,
                  valueGetter: (params) =>
                    params.data?.booking_client_id ||
                    params.data?._source?.booking_client_id,
                },
                {
                  headerName: "Mail Config Status",
                  field: "mailConfigStauts",
                  filter: "agTextColumnFilter",
                  width: 160,
                  valueGetter: (params) =>
                    params.data?.mailConfigStauts ||
                    params.data?._source?.mailConfigStauts,
                },
                {
                  headerName: "Travellers Info",
                  field: "email_travellers_info",
                  filter: "agTextColumnFilter",
                  width: 250,
                  valueGetter: (params) => {
                    const travellers = params.data?.email_travellers_info ||
                      params.data?._source?.email_travellers_info;
                    if (Array.isArray(travellers)) {
                      return travellers.map(t => t?.name || JSON.stringify(t)).join(", ");
                    }
                    return travellers;
                  },
                },
                {
                  headerName: "GST Match Status",
                  field: "gstMatchStatus",
                  filter: "agTextColumnFilter",
                  width: 150,
                  valueGetter: (params) =>
                    params.data?.gstMatchStatus ||
                    params.data?._source?.gstMatchStatus,
                },
                {
                  headerName: "Created At",
                  field: "createdAt",
                  filter: "agDateColumnFilter",
                  width: 150,
                  valueGetter: (params) => {
                    const timestamp = params.data?.createdAt ||
                      params.data?._source?.createdAt;
                    return timestamp ? new Date(parseInt(timestamp)) : null;
                  },
                  valueFormatter: (params) => {
                    if (!params.value) return "";
                    return new Date(params.value).toLocaleString();
                  },
                },
                {
                  headerName: "Last Mail Sent At",
                  field: "last_mail_sent_at",
                  filter: "agDateColumnFilter",
                  width: 180,
                  valueGetter: (params) => {
                    const dateStr = params.data?.last_mail_sent_at ||
                      params.data?._source?.last_mail_sent_at;
                    return dateStr ? new Date(dateStr) : null;
                  },
                  valueFormatter: (params) => {
                    if (!params.value) return "";
                    return new Date(params.value).toLocaleString();
                  },
                },
                {
                  headerName: "Last Mail Type",
                  field: "last_mail_type",
                  filter: "agTextColumnFilter",
                  width: 130,
                  valueGetter: (params) =>
                    params.data?.last_mail_type ||
                    params.data?._source?.last_mail_type,
                },
                {
                  headerName: "Test Mode",
                  field: "testMode",
                  filter: "agTextColumnFilter",
                  width: 100,
                  valueGetter: (params) =>
                    params.data?.testMode ||
                    params.data?._source?.testMode,
                },
                {
                  headerName: "Tracking ID",
                  field: "trackingId",
                  filter: "agTextColumnFilter",
                  width: 200,
                  valueGetter: (params) => {
                    const trackingIds = params.data?.trackingId ||
                      params.data?._source?.trackingId;
                    return Array.isArray(trackingIds) ? trackingIds.join(", ") : trackingIds;
                  },
                },
                {
                  headerName: "Total GST",
                  field: "totalGST",
                  filter: "agNumberColumnFilter",
                  width: 120,
                  valueGetter: (params) => {
                    const value = params.data?.totalGST ||
                      params.data?._source?.totalGST;
                    return value ? parseFloat(value) : null;
                  },
                  valueFormatter: (params) => {
                    if (!params.value) return "";
                    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(params.value);
                  },
                },
              ]}
              rowData={bookingRowData || matchDocument?.booking_matches}
            />
          </div>
        </div>
      ),
    },
  ];
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsNonInvoice(checked);
    if (checked) {
      setSelectedIssue("Not an invoice");
    }
    else {
      setSelectedIssue(null);
    }
  };

  const options = isNonInvoice
    ? [{ value: "Non invoice", label: "Non invoice" }]
    : [
      { value: "E-invoice", label: "E-invoice" },
      { value: "Compliant Tax Invoice", label: "Compliant Tax Invoice" },
      { value: "Informational Invoice", label: "Informational Invoice" },
      { value: "Non-compliant Invoice", label: "Non-compliant Invoice" },
      { value: "Non-compliant Invoice Hence Not Matched", label: "Non-compliant Invoice Hence Not Matched" },
      { value: "Not an invoice", label: "Not an invoice" },
    ];

  console.log(assetLink, "assetLink check")

  return (
    <div className="NewMatchPage">
      <PageHeader
        title="Manual Validation"
        leftActions={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "400px", display: "flex", alignItems: "center", gap: "12px" }}>
              <Select
                style={{ width: 150 }}
                value={filterType}
                onChange={(value) => {
                  // Clear all filter-related state
                  setFilterValue("");
                  setCurrentFilterPanNumbers([]);
                  setCurrentFilterGstinNumbers([]);

                  if (value === "All") {
                    // Remove all filters and fetch all documents
                    setFilterType("All");
                    fetchDocument(); // Fetch all documents without any filter
                  } else {
                    // Set new filter type
                    setFilterType(value);
                  }
                }}
              >
                <Option value="All">All</Option>
                <Option value="client_name">client_name</Option>
                <Option value="hotel_gstin">hotel_gstin</Option>
                <Option value="client_gstin">client_gstin</Option>
              </Select>

              {filterType === "client_name" && (
                <Select
                  style={{ width: 200 }}
                  placeholder="Select Client"
                  loading={clientListLoading}
                  value={filterValue}
                  onChange={(value) => {
                    setFilterValue(value);
                    // Call API when client is selected
                    if (value) {
                      // Find the selected client to get PAN numbers
                      const selectedClientData = clientList.find(client => client.client_name === value);
                      const panNumbers = selectedClientData?.pan_numbers || [];
                      setCurrentFilterPanNumbers(panNumbers); // Store PAN numbers for skip functionality
                      // Send client_name and pan_numbers
                      fetchDocument({
                        type: filterType,
                        value: value,
                        pan_numbers: panNumbers
                      });
                    }
                  }}
                  onFocus={() => {
                    // Fetch client list when dropdown is focused/opened
                    if (clientList.length === 0) {
                      fetchClientInfoByPan();
                    }
                  }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  options={clientList.map(client => ({
                    label: client.client_name,
                    value: client.client_name,
                  }))}
                />
              )}
              {filterType === "hotel_gstin" && (
                <Input
                  style={{ width: 200 }}
                  placeholder="Enter hotel GSTIN(s) comma-separated, press Enter"
                  value={filterValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFilterValue(value);
                  }}
                  onPressEnter={(e) => {
                    const value = e.target.value;
                    // Call API only when Enter is pressed
                    if (value.trim()) {
                      setCurrentFilterPanNumbers([]); // Clear PAN numbers for non-client_name filters
                      // Parse comma-separated GSTIN numbers
                      const gstinNumbers = value.split(',').map(gstin => gstin.trim()).filter(gstin => gstin);
                      setCurrentFilterGstinNumbers(gstinNumbers);
                      fetchDocument({
                        type: filterType,
                        value: value.trim(),
                        gstin_numbers: gstinNumbers
                      });
                    }
                  }}
                />
              )}
              {filterType === "client_gstin" && (
                <Input
                  style={{ width: 200 }}
                  placeholder="Enter client GSTIN(s) comma-separated, press Enter"
                  value={filterValue}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFilterValue(value);
                  }}
                  onPressEnter={(e) => {
                    const value = e.target.value;
                    // Call API only when Enter is pressed
                    if (value.trim()) {
                      setCurrentFilterPanNumbers([]); // Clear PAN numbers for non-client_name filters
                      // Parse comma-separated GSTIN numbers
                      const gstinNumbers = value.split(',').map(gstin => gstin.trim()).filter(gstin => gstin);
                      setCurrentFilterGstinNumbers(gstinNumbers);
                      fetchDocument({
                        type: filterType,
                        value: value.trim(),
                        gstin_numbers: gstinNumbers
                      });
                    }
                  }}
                />
              )}
            </div>
          </div>
        }
        rightActions={
          !documentId ? (
            <div className="PaginationContainer" style={{ display: 'flex', gap: '6px' }}>
              <Button color="default" variant="outlined" style={{ color: '#0a8394', borderColor: "#0a8394" }}>
                {currenntDoc} of {totalCount}
              </Button>
              <Button
                color="default"
                style={{ color: '#0a8394', borderColor: "#0a8394" }}
                variant="outlined"
                icon={<ArrowRightOutlined />}
                onClick={handleSkipDocument}
              />
            </div>
          ) : null
        }
        showWorkspaceDropdown={false}
      />
      <div className="MainContentContainer">
        <div
          style={{
            width: dimensions.width,
            height: dimensions.height,
            resize: 'both',
            overflow: 'hidden',
            position: 'relative',
            border: '1px solid #ccc',
          }}
          onMouseMove={onResize}
          onMouseUp={stopResizing}
          onMouseLeave={stopResizing}
        >
          <embed
            src={assetLink}

            type="application/pdf"
            width="100%"
            height="100%"
          />
          <div
            onMouseDown={startResizing}
            style={{
              width: '10px',
              height: '10px',
              background: '#ccc',
              position: 'absolute',
              bottom: 0,
              right: 0,
              cursor: 'nwse-resize',
            }}
          />
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1',
          height: '100%',
          justifyContent: "space-between"
        }}>
          <div className="DataPreviewContainer">
            {isLoading ? (
              "Loading..."
            ) : (
              <>
                <div className="DataCollectionContainer"
                >
                  {/* <Checkbox checked={isNonInvoice} onChange={handleCheckboxChange}>
                  Non-invoice
                </Checkbox> */}
                  <Collapse items={items} defaultActiveKey={["1", "2", "3"]} onChange={handleCollapseChange} />
                </div>
                <div className="MatchResultContainer">
                  <div className="RemarksContainer">
                    <TextArea
                      rows={4}
                      placeholder="Add your remarks"
                      onChange={(event) => setRemarks(event.target.value)}
                      value={remarks}
                    />
                  </div>
                </div>

              </>
            )}
          </div>
          <div className="ActionContainer"
            style={{
              marginBottom: "20px",
              padding: '20px',
              display: 'flex',
              justifyContent: "flex-end",
            }}>
            <Button
              style={{
                color: "#0a8394",
                borderColor: "#0a8394",
                fontSize: '14px',
                fontWeight: 600,
                flexDirection: "row-reverse",
                width: "80px"
              }}
              icon={<DoubleRightOutlined />}
              onClick={handleSkipDocument}
            >
              Skip
            </Button>

            <Button
              type="primary"
              style={{
                marginLeft: 18,
                backgroundColor: "#0a8394",
                width: "90px",
                //opacity:0.16,
                color: "#FFFFFF",
                fontSize: '14px',
                fontWeight: 600,
                opacity: isSaveDisabled ? 0.16 : 1, // 👈 dynamic opacity
                cursor: isSaveDisabled ? "not-allowed" : "pointer",
              }}
              onClick={handleSaveCollection}
              disabled={isSaveDisabled}
            >
              Save
            </Button>
          </div>
        </div>

      </div>
      <Drawer
        title="Add GSTIN"
        placement="right"
        onClose={closeDrawer} // Close the Drawer
        open={isDrawerOpen} // Control visibility with state
        width={600} // Set the width of the Drawer
      >
        {/* Render the AddGSTIN component inside the Drawer */}
      </Drawer>
      {contextHolder}
    </div>
  );
}





